// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .transalte-form-dialog-content .mat-dialog-container {
  width: 1000px;
}

::ng-deep .form-tran-header .mat-dialog-title {
  margin: 0 0 10px;
}

::ng-deep .transalte-form-dialog-content {
  min-width: 20vw;
  max-width: 1033px;
}

.form-tran-container {
  height: calc(65vh - 100px);
  max-height: calc(65vh - 100px);
  overflow: auto;
  table-layout: fixed;
}
.form-tran-container table {
  margin-bottom: 4px;
}

.cus-matchip {
  min-height: 1px !important;
  align-self: center;
  font-size: 12px;
  color: white !important;
}

.block-section {
  display: flex;
  justify-content: space-between;
}

.lang-header {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 150px;
}

.form-tran-container .mat-header-cell,
.mat-footer-cell,
.mat-cell {
  min-width: 150px;
  box-sizing: border-box;
}

.margin-left-15 {
  margin-left: 15px;
}

.margin-left-10 {
  margin-left: 10px;
}

.colum-type1 {
  min-width: 180px;
  max-width: 180px;
}

.no-data {
  background: aliceblue;
  text-align: center;
  font-size: 12px;
  color: gray;
  height: 90%;
  display: flex;
  justify-content: center;
}

.form-tran-container .mat-table-sticky {
  cursor: pointer;
  opacity: 1;
}

::ng-deep .transalte-form-dialog-content .mat-tab-label {
  height: 30px;
  min-width: 120px;
}
::ng-deep .transalte-form-dialog-content .mat-tab-label .mat-tab-label-content {
  font-size: 13px;
  font-weight: bold;
}

::ng-deep .transalte-form-dialog-content-scale .mat-tab-label {
  min-width: 200px;
}

th.mat-header-cell {
  text-align: center;
}

.mat-table tr.mat-row:hover,
.mat-table .mat-row:hover {
  cursor: pointer;
  background-color: white;
}

.form-tran-header .mat-dialog-title {
  display: flex;
  justify-content: space-between;
}

.mat-menu-item .mat-icon {
  color: orange;
  margin-right: 8px;
}

.menu-tool {
  display: none;
  position: absolute;
  left: 55px;
  top: 24px;
  background: whitesmoke;
  border-radius: 5px;
}
.menu-tool mat-icon {
  font-size: 17px;
  height: 17px;
}
.menu-tool mat-icon:hover {
  background-color: wheat;
}

.menu-disabled {
  display: none;
}

.range {
  border-radius: 4px;
  height: 30px;
  display: inline-block;
  padding: 8px;
  font-size: 12px;
  color: gray;
  -webkit-user-select: none;
          user-select: none;
  background-color: transparent;
  z-index: 100;
  transition: background-color 0.2s;
}

.range.enabled:hover,
.range.active {
  background-color: aliceblue;
  cursor: pointer;
}

.menu-show {
  display: block;
}

.paginator-block {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 1px;
}

.menu-tricker {
  width: 15%;
  color: gray;
  align-self: flex-end;
  right: 27%;
  margin-bottom: -7px;
}

.trigger {
  height: 40px;
}

.header-menu {
  display: flex;
}
.header-menu mat-select {
  align-self: center;
}
.header-menu mat-icon {
  font-size: medium;
  height: 26px;
}
.header-menu .mat-icon-button {
  width: auto;
}

:host .mat-menu-panel .mat-menu-item {
  width: 100%;
}

.header-menu:hover .menu-tool {
  display: block;
}

.group-search-form input {
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 30px;
  outline: none;
  line-height: 30px;
  padding: 0 8px 0 30px;
  max-width: 360px;
  height: 30px;
  transition: max-width 0.2s ease-in-out;
}

.group-search-form input::-webkit-input-placeholder {
  color: #999;
}

.group-search-form input:focus::-webkit-input-placeholder {
  color: #ccc;
}

.group-search-form input::-moz-placeholder {
  color: #999;
}

.group-search-form input:focus::-moz-placeholder {
  color: #ccc;
}

.group-search-form .fa-search {
  background: transparent;
  color: #aaa;
  font-size: 16px;
  border: none;
  outline: none;
  padding: 0;
  position: absolute;
  left: 0;
  top: 0;
  height: 30px;
}

.group-search-resize input {
  max-width: 60%;
}

.translate-input-style {
  line-height: 15px;
}

.group-search-form .fa-search:before {
  position: absolute;
  top: 6px;
  left: 9px;
}

.group-search-form {
  padding: 0;
  position: fixed;
  margin-top: 3px;
}

.form-tran-container table th {
  background: #80d9e4;
  border-left: 2.5px solid white;
  border-bottom: none;
}

.form-tran-container table th:first-child {
  border-left: none;
}

.form-tran-container table td:first-child {
  padding-left: 1px;
  background: #fafafa;
  border-right: 2.5px solid white;
  border-bottom: 2.5px solid white;
}

::ng-deep .paginator-header .mat-paginator-icon {
  width: 20px !important;
}

::ng-deep .paginator-header .mat-paginator {
  margin-top: 23px;
}

::ng-deep .paginator-header .mat-paginator-container {
  height: 10px;
  min-height: 1px;
}

::ng-deep .form-tran-container .mat-form-field-label {
  font-size: 11px !important;
  font-weight: bold;
}

::ng-deep .form-tran-container .mat-form-field-wrapper {
  margin: 0px !important;
  font-size: 11px !important;
}

::ng-deep .mat-button-focus-overlay {
  display: none;
}

::ng-deep .mat-paginator-page-size {
  display: none !important;
}

::ng-deep .mat-paginator-range-label {
  display: none !important;
}

::ng-deep .form-tran-container .mat-table td.mat-cell {
  border: none;
}

::ng-deep .form-tran-container .mat-form-field-appearance-outline .mat-form-field-infix {
  font-size: 11px !important;
  padding: 8px 1px !important;
  margin-top: -5px;
  line-height: 1;
}

::ng-deep .form-tran-container .mat-form-field-appearance-outline .mat-form-field-flex {
  margin-top: 1px;
}

::ng-deep .form-tran-container th.mat-header-cell:last-of-type, td.mat-cell:last-of-type, td.mat-footer-cell:last-of-type {
  padding: 0px;
}

::ng-deep .form-tran-container .mat-table td.mat-cell, .mat-table td.mat-footer-cell, .mat-table th.mat-header-cell {
  padding: 0 2px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/e-form/dialog/form-translate/form-translate.component.scss"],"names":[],"mappings":"AAAA;EACG,aAAA;AACH;;AAEA;EACG,gBAAA;AACH;;AAEA;EACI,eAAA;EACA,iBAAA;AACJ;;AAEA;EACG,0BAAA;EACA,8BAAA;EACA,cAAA;EACA,mBAAA;AACH;AAAG;EACG,kBAAA;AAEN;;AAEA;EACG,0BAAA;EACA,kBAAA;EACA,eAAA;EACA,uBAAA;AACH;;AAEA;EACG,aAAA;EACA,8BAAA;AACH;;AAEA;EACG,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AACH;;AAEA;;;EAGG,gBAAA;EACA,sBAAA;AACH;;AAEA;EACG,iBAAA;AACH;;AAEA;EACG,iBAAA;AACH;;AAEA;EACG,gBAAA;EACC,gBAAA;AACJ;;AAEA;EACG,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;AACH;;AAEA;EACG,eAAA;EACA,UAAA;AACH;;AAIG;EACG,YAAA;EACA,gBAAA;AADN;AAEM;EACG,eAAA;EACA,iBAAA;AAAT;;AAKA;EACG,gBAAA;AAFH;;AAKA;EACG,kBAAA;AAFH;;AAKA;;EAEG,eAAA;EACA,uBAAA;AAFH;;AAMG;EACG,aAAA;EACA,8BAAA;AAHN;;AAOA;EACG,aAAA;EACA,iBAAA;AAJH;;AAOA;EACG,aAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,sBAAA;EACA,kBAAA;AAJH;AAMG;EACG,eAAA;EACA,YAAA;AAJN;AAOG;EACG,uBAAA;AALN;;AASA;EACG,aAAA;AANH;;AASA;EACG,kBAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6BAAA;EACA,YAAA;EACA,iCAAA;AANH;;AASA;;EAEG,2BAAA;EACA,eAAA;AANH;;AASA;EACG,cAAA;AANH;;AASA;EACG,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;AANH;;AASA;EACG,UAAA;EACA,WAAA;EACA,oBAAA;EACA,UAAA;EACA,mBAAA;AANH;;AASA;EACG,YAAA;AANH;;AASA;EACG,aAAA;AANH;AAQG;EACG,kBAAA;AANN;AASG;EACG,iBAAA;EAEA,YAAA;AARN;AAWG;EACG,WAAA;AATN;;AAaA;EACG,WAAA;AAVH;;AAaA;EACG,cAAA;AAVH;;AAaA;EACG,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,iBAAA;EACA,qBAAA;EACA,gBAAA;EACA,YAAA;EACA,sCAAA;AAVH;;AAcA;EACG,WAAA;AAXH;;AAcA;EACG,WAAA;AAXH;;AAcA;EACG,WAAA;AAXH;;AAcA;EACG,WAAA;AAXH;;AAcA;EACG,uBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;AAXH;;AAcA;EACG,cAAA;AAXH;;AAcA;EACG,iBAAA;AAXH;;AAcA;EACG,kBAAA;EACA,QAAA;EACA,SAAA;AAXH;;AAcA;EACG,UAAA;EACA,eAAA;EACA,eAAA;AAXH;;AAcA;EACG,mBAAA;EACA,8BAAA;EACA,mBAAA;AAXH;;AAcA;EACG,iBAAA;AAXH;;AAcA;EACC,iBAAA;EACA,mBAAA;EACA,+BAAA;EACA,gCAAA;AAXD;;AAcA;EACG,sBAAA;AAXH;;AAcA;EACG,gBAAA;AAXH;;AAcA;EACG,YAAA;EACA,eAAA;AAXH;;AAcA;EACG,0BAAA;EACA,iBAAA;AAXH;;AAcA;EACG,sBAAA;EACA,0BAAA;AAXH;;AAcA;EACG,aAAA;AAXH;;AAcA;EACG,wBAAA;AAXH;;AAcA;EACG,wBAAA;AAXH;;AAcA;EACG,YAAA;AAXH;;AAcA;EACG,0BAAA;EACA,2BAAA;EACA,gBAAA;EACA,cAAA;AAXH;;AAcA;EACG,eAAA;AAXH;;AAcA;EACG,YAAA;AAXH;;AAcA;EACG,yBAAA;AAXH","sourcesContent":["::ng-deep .transalte-form-dialog-content .mat-dialog-container {\n   width: 1000px;\n}\n\n::ng-deep .form-tran-header .mat-dialog-title {\n   margin: 0 0 10px;\n}\n\n::ng-deep .transalte-form-dialog-content {\n    min-width: 20vw;\n    max-width: 1033px;\n}\n\n.form-tran-container {\n   height: calc(65vh - 100px);\n   max-height: calc(65vh - 100px);\n   overflow: auto;\n   table-layout: fixed;\n   table {\n      margin-bottom: 4px;\n   }\n}\n\n.cus-matchip {\n   min-height: 1px !important;\n   align-self: center;\n   font-size: 12px;\n   color: white !important;\n}\n\n.block-section {\n   display: flex;\n   justify-content: space-between;\n}\n\n.lang-header {\n   overflow: hidden;\n   white-space: nowrap;\n   text-overflow: ellipsis;\n   width: 150px;\n}\n\n.form-tran-container .mat-header-cell,\n.mat-footer-cell,\n.mat-cell {\n   min-width: 150px;\n   box-sizing: border-box;\n}\n\n.margin-left-15 {\n   margin-left: 15px;\n}\n\n.margin-left-10 {\n   margin-left: 10px;\n}\n\n.colum-type1 {\n   min-width: 180px;\n    max-width: 180px;\n}\n\n.no-data {\n   background: aliceblue;\n   text-align: center;\n   font-size: 12px;\n   color: gray;\n   height: 90%;\n   display: flex;\n   justify-content: center;\n}\n\n.form-tran-container .mat-table-sticky {\n   cursor: pointer;\n   opacity: 1;\n}\n\n::ng-deep .transalte-form-dialog-content {\n\n   .mat-tab-label {\n      height: 30px;\n      min-width: 120px;\n      .mat-tab-label-content {\n         font-size: 13px;\n         font-weight: bold;\n      }\n   }\n}\n\n::ng-deep .transalte-form-dialog-content-scale .mat-tab-label {\n   min-width: 200px;\n }\n\nth.mat-header-cell {\n   text-align: center;\n}\n\n.mat-table tr.mat-row:hover,\n.mat-table .mat-row:hover {\n   cursor: pointer;\n   background-color: white;\n}\n\n.form-tran-header {\n   .mat-dialog-title {\n      display: flex;\n      justify-content: space-between;\n   }\n}\n\n.mat-menu-item .mat-icon {\n   color: orange;\n   margin-right: 8px;\n}\n\n.menu-tool {\n   display: none;\n   position: absolute;\n   left: 55px;\n   top: 24px;\n   background: whitesmoke;\n   border-radius: 5px;\n\n   mat-icon {\n      font-size: 17px;\n      height: 17px;\n   }\n\n   mat-icon:hover {\n      background-color: wheat;\n   }\n}\n\n.menu-disabled {\n   display: none;\n}\n\n.range {\n   border-radius: 4px;\n   height: 30px;\n   display: inline-block;\n   padding: 8px;\n   font-size: 12px;\n   color: gray;\n   user-select: none;\n   background-color: transparent;\n   z-index: 100;\n   transition: background-color .2s;\n}\n\n.range.enabled:hover,\n.range.active {\n   background-color: aliceblue;\n   cursor: pointer;\n}\n\n.menu-show {\n   display: block;\n}\n\n.paginator-block {\n   display: flex;\n   flex-direction: row;\n   justify-content: flex-end;\n   margin-top: 1px;\n}\n\n.menu-tricker {\n   width: 15%;\n   color: gray;\n   align-self: flex-end;\n   right: 27%;\n   margin-bottom: -7px;\n}\n\n.trigger {\n   height: 40px;\n}\n\n.header-menu {\n   display: flex;\n\n   mat-select {\n      align-self: center;\n   }\n\n   mat-icon {\n      font-size: medium;\n\n      height: 26px;\n   }\n\n   .mat-icon-button {\n      width: auto;\n   }\n}\n\n:host .mat-menu-panel .mat-menu-item {\n   width: 100%;\n}\n\n.header-menu:hover .menu-tool {\n   display: block;\n}\n\n.group-search-form input {\n   background: #fff;\n   border: 1px solid #ccc;\n   border-radius: 30px;\n   outline: none;\n   line-height: 30px;\n   padding: 0 8px 0 30px;\n   max-width: 360px;\n   height: 30px;\n   transition: max-width .2s ease-in-out;\n}\n\n\n.group-search-form input::-webkit-input-placeholder {\n   color: #999;\n}\n\n.group-search-form input:focus::-webkit-input-placeholder {\n   color: #ccc;\n}\n\n.group-search-form input::-moz-placeholder {\n   color: #999;\n}\n\n.group-search-form input:focus::-moz-placeholder {\n   color: #ccc;\n}\n\n.group-search-form .fa-search {\n   background: transparent;\n   color: #aaa;\n   font-size: 16px;\n   border: none;\n   outline: none;\n   padding: 0;\n   position: absolute;\n   left: 0;\n   top: 0;\n   height: 30px;\n}\n\n.group-search-resize input{\n   max-width: 60%;\n}\n\n.translate-input-style {\n   line-height: 15px;\n}\n\n.group-search-form .fa-search:before {\n   position: absolute;\n   top: 6px;\n   left: 9px;\n}\n\n.group-search-form {\n   padding: 0;\n   position: fixed;\n   margin-top: 3px;\n}\n\n.form-tran-container table th {\n   background: #80d9e4;\n   border-left: 2.5px solid white;\n   border-bottom: none;\n}\n\n.form-tran-container table th:first-child {\n   border-left: none;\n}\n\n.form-tran-container table td:first-child {\n padding-left: 1px;\n background: #fafafa;\n border-right: 2.5px solid white;\n border-bottom: 2.5px solid white;\n}\n\n::ng-deep .paginator-header .mat-paginator-icon {\n   width: 20px !important;\n}\n\n::ng-deep .paginator-header .mat-paginator {\n   margin-top: 23px;\n}\n\n::ng-deep .paginator-header .mat-paginator-container {\n   height: 10px;\n   min-height: 1px;\n}\n\n::ng-deep .form-tran-container .mat-form-field-label {\n   font-size: 11px !important;\n   font-weight: bold;\n}\n\n::ng-deep .form-tran-container .mat-form-field-wrapper {\n   margin: 0px !important;\n   font-size: 11px !important;\n}\n\n::ng-deep .mat-button-focus-overlay {\n   display: none;\n}\n\n::ng-deep .mat-paginator-page-size {\n   display: none !important;\n}\n\n::ng-deep .mat-paginator-range-label {\n   display: none !important;\n}\n\n::ng-deep .form-tran-container .mat-table td.mat-cell {\n   border: none;\n}\n\n::ng-deep .form-tran-container .mat-form-field-appearance-outline .mat-form-field-infix {\n   font-size: 11px !important;\n   padding: 8px 1px !important;\n   margin-top: -5px;\n   line-height: 1.00;\n}\n\n::ng-deep .form-tran-container .mat-form-field-appearance-outline .mat-form-field-flex {\n   margin-top: 1px;\n}\n\n::ng-deep .form-tran-container th.mat-header-cell:last-of-type, td.mat-cell:last-of-type, td.mat-footer-cell:last-of-type {\n   padding: 0px;\n}\n\n::ng-deep .form-tran-container .mat-table td.mat-cell, .mat-table td.mat-footer-cell, .mat-table th.mat-header-cell {\n   padding: 0 2px !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
